'use strict';

module.exports = require('./browser/algorithms.json');



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 451
// module chunks = 42